import { module } from 'angular';
import kformErrorsTemplate from './kform-errors.html';

export default module('app')
	.run(/* @ngInject */ $templateCache => {
		$templateCache.put('kform-errors.html', kformErrorsTemplate);
	});
